var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dx-report-tip"},[_c('span',{staticClass:"dx-report-tip__icon"},[_c('icon',{attrs:{"name":"exclamation-triangle"}})],1),_vm._v(" "),_c('span',{staticClass:"dx-report-tip__text"},[_vm._v("\n    "+_vm._s(_vm.$t('reportTip'))+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79dfb68e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DxReportTip.vue
// module id = null
// module chunks = 